module.exports = __webpack_public_path__ + "fonts/Roboto-Light.08cf97f4.eot";